import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import { Fade, Slide } from "react-awesome-reveal";
import { useEffect, useState } from 'react';
import { bannerList, bannerPage } from '../../API';
import { useNavigate } from 'react-router';


export default function Home() {
  const [banner, setBanner]: any = useState()
  const handleLoad = () => {
    bannerList().then((res) => {
      setBanner(res.data) 
    }).catch((err) => {
      console.log(err)
    })
  }
  useEffect(() => {
    handleLoad()
  }, [])
  const navigate = useNavigate()


  return (
    <div className=' '>
      <div className='h-[612px] h5:h-[582px]'>
        <Swiper
          slidesPerView={1}
          autoplay={{
            delay: 5000,
            // disableOnInteraction: false,
          }}
          loop={true}
          modules={[Autoplay, Pagination]}
          pagination={{
            clickable: true,  // 使指示点可点击
            bulletClass: 'swiper-pagination-bullet',  // 指示点的类名
            bulletActiveClass: 'swiper-pagination-bullet-active',  // 活动指示点的类名
          }}
        >
          {
            banner?.map((item: any) => (
              <SwiperSlide style={{
                display: item?.status === 1 ? 'block' : 'none',
                cursor: item?.jumpUrl ? 'pointer' : 'default'
              }}
                onClick={() => {
                  if (item?.jumpUrl) {
                    window.open(item?.jumpUrl)
                  }
                }}>
                <div className='w-full h-[664px] h5:h-[592px] '
                  style={{
                    backgroundImage: `url("${item?.showUrl}")`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="w-[1200px] mx-auto h5:w-full relative">
                    <Fade cascade={true} direction="up" delay={100} duration={600} className={item?.description ? 'block' : 'hidden'}>
                      <div className="text-[#181512] text-[40px] font-bold pt-[230px] h5:pt-[190px] h5:text-center whitespace-pre-line">{item?.description} </div>
                      {/* <div className="text-[#181512] text-[40px] font-bold pt-2 pb-20 h5:text-center">別客氣進來坐 </div> */}
                      <div className='h5:flex h5:justify-center h5:items-center'>
                        <div className="bg-[#181512] inline-block rounded-[6px] cursor-pointer text-[#fff] text-[14px] font-bold px-[20px] py-[10px] mt-4 ">Feel at home {'>'}</div>
                      </div>
                    </Fade>
                  </div>
                </div>
              </SwiperSlide>
            ))
          }
        </Swiper>
      </div>
    </div>
  );
}
